import { Text } from "@mantine/core";
import {
  getTimezoneOffset,
  incrementHour,
} from "../../../../../functions/dates";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useProfileStore } from "../../../../../stores/UserStore";

export const CampaignStartingHour = () => {
  const lang = useLanguage.getState().language;
  return {
    field: "time_start_sending",
    headerName: lang.statistics.columns.time_start_sending,
    width: 175,
    sortable: false,
    filterable: false,
    valueGetter: ({ row }) => {
      if (row?.isChild) {
        return "";
      }
      // let timezoneOffset = getTimezoneOffset();

      // const time_start_sending = incrementHour(
      //   row?.["time_start_sending"],
      //   -timezoneOffset
      // );

      // return time_start_sending;

      return `${row?.time_start_sending || ""}`;
    },
    renderCell: ({ row, value }) => {
      if (!row) {
        return;
      }
      if (row.isChild) {
        return "";
      }
      return <Text>{value}</Text>;
    },
  };
};
